import {
  COMPANY_CREATE,
  COMPANY_UPDATE,
  COMPANY_DELETE,
  COMPANY_ACTIVATE,
  USER_CREATE,
  USER_UPDATE,
  COMMODULE_CREATE,
  COMMODULE_READ,
  COMMODULE_DELETE,
  USER_DELETE,
  MEASURINGPOINT_CREATE,
  TRANSFER_CREATE,
  TABLETS_MANAGE,
  TOUR_IMPORT,
  TOUR_MANAGEMENT,
  TOUR_EXPORT,
  TOUR_ASSIGN,
  TOUR_CLOSE,
  TOUR_REASSIGN,
  TOUR_RESTORE,
  TOUR_DISCARD,
  TOUR_DELETE,
  CRM_IMPORT,
} from '@/state/helpers/permissions.js'

// Map action to permissions
const btns = {}
const icons = {}

btns.export = {label: 'export'}
btns.edit = {label: 'edit'}
btns.discard = {label: 'discard'}
btns.create_company = {label: 'company_create', permission: COMPANY_CREATE}
btns.edit_company = {label: 'edit', permission: COMPANY_UPDATE}
btns.delete_company = {label: 'delete', permission: COMPANY_DELETE}
btns.create_device = {label: 'device_create', permission: COMMODULE_CREATE}
btns.create_group = {label: 'group_create'}
btns.view_alerts = {label: 'alerts_view'}
btns.create_user = {label: 'user_create', permission: USER_CREATE}
btns.import_tour = {label: 'tour_import', permission: TOUR_IMPORT}
btns.manage_tablets = {label: 'manage_tablets', permission: TABLETS_MANAGE}
btns.export_tour = {label: 'tour_export', permission: TOUR_EXPORT}
btns.assign_tour = {label: 'tour_assign', permission: TOUR_ASSIGN}
btns.unassign_tour = {label: 'tour_unassign', permission: TOUR_ASSIGN}
btns.simulate_readout = {label: 'simulate_readout'}
btns.reassign_tour = {label: 'tour_reassign', permission: TOUR_REASSIGN}
btns.restore_tour = {label: 'tour_restore', permission: TOUR_RESTORE}
btns.discard_tour = {label: 'tour_discard', permission: TOUR_DISCARD}
btns.delete_tour = {label: 'tour_delete', permission: TOUR_DELETE}
btns.create_device_group = {label: 'device_group_create'}
btns.update_device_group = {label: 'device_group_update'}
btns.delete_device_group = {label: 'device_group_delete'}
btns.update_device_group_add_device = {label: 'device_group_add_device'}
btns.update_device_group_remove_device = {label: 'device_group_remove_device'}
btns.close_tour = {label: 'tour_close', permission: TOUR_CLOSE}
btns.create_measuring_point = {label: 'measuring_point_create', permission: MEASURINGPOINT_CREATE}
btns.transfer = {label: 'transfer', permission: TRANSFER_CREATE}
btns.update = {label: 'update'}
btns.change_password = {label: 'change_password'}
btns.save = {label: 'save'}
btns.import = {label: 'import'}
btns.submit = {label: 'submit'}
btns.clear = {label: 'clear'}
btns.clear_filters = {label: 'clear_filters'}
btns.next = {label: 'next'}
btns.previous = {label: 'previous'}
btns.close = {label: 'close'}
btns.json = {label: 'JSON'}
btns.csv = {label: 'CSV'}
btns.xml = {label: 'XML'}
btns.xlsx = {label: 'XLSX'}
btns.sign_in = {label: 'sign_in'}
btns.send_password_link = {label: 'password_send_link'}
btns.select_company = {label: 'select_company'}
btns.activate_account = {label: 'account_activate'}
btns.reset_password = {label: 'password_reset'}
btns.import_company = {label: 'company_import', permission: CRM_IMPORT}
btns.search = {label: 'search'}
btns.register_lora = {label: 'register_lora'}
btns.register = {label: 'register'}
btns.unregister = {label: 'unregister'}
btns.update_map = {label: 'map_update'}
btns.search_by_address = {label: 'address_search'}
btns.reset_changes = {label: 'reset_changes'}
btns.stop_impersonate = {label: 'stop_impersonate'}
btns.report_config = {label: 'chart_config'}

icons.delete_user = {tooltip: 'delete', icon: 'delete', permission: USER_DELETE}
icons.edit_user = {tooltip: 'edit', icon: 'edit', permission: USER_UPDATE}
icons.activate_user = {tooltip: 'activate', icon: 'activate-user', permission: USER_UPDATE}
icons.activate_company = {tooltip: 'activate', icon: 'external-link', permission: COMPANY_ACTIVATE}
icons.view_key = {tooltip: 'Keys', icon: 'key', permission: COMMODULE_READ}
icons.view_invoice = {tooltip: 'Document', icon: 'invoice'}
icons.impersonate_user = {tooltip: 'Impersonate', icon: 'users'}
icons.close = {tooltip: 'Close', icon: 'close'}
icons.clear_filters = {tooltip: 'clear_filters', icon: 'filters-clear'}
icons.previous = {tooltip: 'previous', icon: 'arrow-left'}
icons.next = {tooltip: 'next', icon: 'arrow-right'}
icons.zoom_out = {tooltip: 'zoom_out', icon: 'zoom-out'}

export {btns, icons}
